import { Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
/**
 * This is a dummy pipe that works simular as the translate pipe of ngx-translate/core
 */
@Pipe({
    name: 'enum',
    pure: true,
})
export class EnumTranslatePipe implements PipeTransform {
    _value: string;
    lastKey: string;
    lastValue: string;
    lastStart: number;
    lastEnd: number;
    constructor(private _translateService: TranslateService) {
        this._translateService.onLangChange.pipe(takeUntilDestroyed()).subscribe(() => {
            this.lastKey = null;
            this.lastValue = null;
        });
    }

    transform(value: string, key: string, start?: number, end?: number): string {
        if (!key || !value) {
            return value;
        }

        if (value == this.lastValue && key == this.lastKey && start == this.lastStart && end == this.lastEnd) {
            //console.log('cached');
            return this._value;
        }
        this.lastValue = value;
        this.lastStart = start;
        this.lastEnd = end;
        this.lastKey = key;

        //console.log('changed');
        if (start != undefined && end != undefined) {
            return (this._value = this._translateService.instant(`ENUM.${key}.${value}`).substring(start, end));
        } else {
            return (this._value = this._translateService.instant(`ENUM.${key}.${value}`));
        }
    }
}
